import React from "react";
import { useParams, useNavigate, useLocation } from "react-router";
import { api } from "store/slices/api";
import { useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import DuplicateQuoteModal from "./modals/DuplicateQuoteModal";
import RefreshPricesModal from "./modals/RefreshPricesModal";
import Button from "react-bootstrap/Button";
import PublishToPunchoutModal from "./punchout/PublishToPunchoutModal";
import { useBoolVariation } from "@launchdarkly/react-sdk";

const QuoteHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { quoteId, floorId } = useParams();
  const { terrCcn, storeCcn, hasUpdateAccess } = useSelector((state) => state.loggedInUser);
  const { data = {} } = api.useGetPriceQuoteQuery(quoteId);
  const { quoteName, territory, storeNumber } = data;
  const { data: floorData } = api.useGetPriceQuoteFloorQuery(floorId, { skip: floorId === undefined });
  const showPunchoutButtonFeatureFlag = useBoolVariation("punchout", false);
  const canEdit = (territory === terrCcn && territory !== "800100") || storeCcn === storeNumber;
  const accountNumber = data.accountNumber === "N/A" ? "" : data.accountNumber;
  const { data: accounts = [], isFetching: isFetchingAccounts } = api.useGetAccountsQuery(
    { customerNumber: accountNumber },
    { skip: !accountNumber },
  );

  const accountIsEligible = accounts[0]?.fcCatalogType === "both" || accounts[0]?.fcCatalogType === "punchout";

  return (
    <Container fluid="xl" className="p-0 bg-white" style={{ position: "sticky", top: 58, zIndex: 9 }}>
      <div
        className="d-flex justify-content-between px-3 py-2 bg-white"
        style={{ border: "1px solid #d1d1d1", borderRadius: "8px 8px 0 0" }}
      >
        <div className="d-flex align-items-center">
          <Button variant="light" className="bg-white" onClick={() => navigate(-1)}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.5466 9.88L18.6666 8L10.6666 16L18.6666 24L20.5466 22.12L14.44 16L20.5466 9.88Z"
                fill="black"
              />
            </svg>
          </Button>
          <Button
            variant="light"
            className="bg-white fs-5 fw-bold"
            onClick={() => navigate(`/priceQuote/${quoteId}#quote-summary`)}
          >
            {quoteName}
          </Button>
          {floorId !== undefined && floorData?.floorName}
        </div>
        <div className="d-flex justify-content-end">
          {location.pathname.endsWith(quoteId) && (
            <>
              {accountNumber &&
                !isFetchingAccounts &&
                canEdit &&
                showPunchoutButtonFeatureFlag &&
                hasUpdateAccess &&
                accountIsEligible && <PublishToPunchoutModal quoteId={quoteId} />}
              <DuplicateQuoteModal />
              {canEdit && data.punchoutPublished !== true && (
                <Button variant="outline-primary" onClick={() => navigate(`/priceQuote/${quoteId}/bulkUpdateQuote`)}>
                  Bulk Update Price
                </Button>
              )}
              <RefreshPricesModal />
            </>
          )}
          {location.pathname.endsWith(floorId) && (
            <Button variant="outline-primary" onClick={() => navigate(`/priceQuote/${quoteId}#quote-summary`)}>
              Back to Quote Summary
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
};

export default QuoteHeader;
